module.exports = __webpack_public_path__ + "img/login_top.0a00d4f7.png";